import axios from 'axios'

export function initialize (store, router) {
  router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const currentUser = store.state.currentUser

    if (requiresAuth && !currentUser) {
      // En caso de login ser requerido y no estarlo
      next({ name: 'login' })
    } else if (!to.matched.length) {
      // En caso que la ruta no exista
      next({ name: 'home' })
    } else if (to.name === 'login' && currentUser) {
      // En caso de ir a login estando logueado
      next({ name: 'home' })
    } else {
      // En el resto de los casos
      next()
    }
  })

  axios.interceptors.response.use(null, (error) => {
    if (error.response.status === 401) {
      store.commit('logout')
      router.push({ name: 'login' })
    }

    return Promise.reject(error)
  })

  if (store.getters.currentUser) {
    setAuthorization(store.getters.currentUser.token)
  }
}

export function setAuthorization (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}



// WEBPACK FOOTER //
// ./src/helpers/general.js